var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegionIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "flag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contents"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 -0.75V18.75H26V-0.75H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_835_3250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 26,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "background_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 -0.75V18.75H26V-0.75H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_835_3250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "top",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 -0.75V5.75H26V-0.75H0Z",
    fill: "#FF8C1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bottom",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.25V18.75H26V12.25H0Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 9C9.75 10.7949 11.2051 12.25 13 12.25C14.7949 12.25 16.25 10.7949 16.25 9C16.25 7.20507 14.7949 5.75 13 5.75C11.2051 5.75 9.75 7.20507 9.75 9ZM15.4375 9.00018C15.4375 10.3464 14.3462 11.4377 13 11.4377C11.6538 11.4377 10.5625 10.3464 10.5625 9.00018C10.5625 7.65399 11.6538 6.56268 13 6.56268C14.3462 6.56268 15.4375 7.65399 15.4375 9.00018Z",
    fill: "#3D58DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9955 9.69933L12.5317 12.2348L12.801 9.67136L11.6417 11.9734L12.6223 9.58974L10.8613 11.4719L12.4738 9.46106L10.2539 10.7709L12.3676 9.29576L9.86855 9.92713L12.3122 9.10722L9.73654 9.00898L12.3122 8.91073L9.86855 8.09082L12.3676 8.72219L10.2539 7.24704L12.4738 8.55689L10.8613 6.54601L12.6223 8.42822L11.6417 6.04451L12.801 8.34659L12.5317 5.78317L12.9955 8.31863L13.4593 5.78317L13.19 8.34659L14.3493 6.04451L13.3687 8.42822L15.1297 6.54601L13.5172 8.55689L15.7371 7.24704L13.6235 8.72219L16.1225 8.09082L13.6788 8.91073L16.2545 9.00898L13.6788 9.10722L16.1225 9.92713L13.6235 9.29576L15.7371 10.7709L13.5172 9.46106L15.1297 11.4719L13.3687 9.58974L14.3493 11.9734L13.19 9.67136L13.4593 12.2348L12.9955 9.69933Z",
    fill: "#3D58DB"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionIn);
export default __webpack_public_path__ + "static/media/region-in.62637b035ea52f73a7c8197397e8dfa8.svg";
export { ForwardRef as ReactComponent };